import moment from 'moment';
import {
  CultivationAgronomyDto
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/cultivation-agronomy-dto';
import { SeedTiming } from './seed-timing.util';

/**
 * Ce que la grille relue (CJ-03) dit d'un sachet : graine ou bulbe, et combien
 * de temps il se garde. Tant que la grille n'est pas importée, `agronomy` est
 * vide et les anciennes règles servent de secours.
 */

/** Durée de garde quand la grille ne la donne pas. */
export const DEFAULT_SEED_LIFESPAN_YEARS = 2;

/**
 * « Bulbes et plants » (K29) : ce qu'on met en terre n'est pas une graine.
 * Sans grille, une culture qui ne se plante que (ail, échalote) en fait partie.
 */
export function isBulbOrPlant(agronomy: CultivationAgronomyDto | null | undefined, timing: SeedTiming | null): boolean {
  if (agronomy?.propagule) return agronomy.propagule !== 'SEED';
  return timing?.kind === 'plant';
}

/** Durée de garde en mois : 0,5 an pour un bulbe fait 6 mois. */
export function seedLifespanMonths(agronomy: CultivationAgronomyDto | null | undefined): number {
  const years = agronomy?.seedLifespanYears;
  return Math.round((years && years > 0 ? years : DEFAULT_SEED_LIFESPAN_YEARS) * 12);
}

/** Date d'expiration d'un sachet ajouté aujourd'hui (`YYYY-MM-DD`). */
export function seedExpirationDate(agronomy: CultivationAgronomyDto | null | undefined, from: moment.Moment = moment()): string {
  return from.clone().add(seedLifespanMonths(agronomy), 'months').format('YYYY-MM-DD');
}
